// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.modal-mask[data-v-584b62a6] {
	position: fixed;
	z-index: 1020;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}
.modal-wrapper[data-v-584b62a6] {
	display: table-cell;
	vertical-align: middle;
	max-width: 100vw;
}
.modal-container[data-v-584b62a6] {
	width: -webkit-fit-content;
	width: -moz-fit-content;
	width: fit-content;
	max-width: 95%;
	margin: 0 auto;
	padding: 1em;
	background-color: rgba(32, 32, 32, 1);
	border-radius: 1em;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	transition: all 0.3s ease;
	display: flex;
	flex-direction: column;
	max-height: 90vh;
}
@media (orientation: portrait) and (max-width: 500px) {
.modal-container[data-v-584b62a6] {
		max-width: 100%;
		padding: 1em 0;
}
}
.modal-header[data-v-584b62a6] {
	position: relative;
	text-align: center;
	padding-left: 2em;
	padding-right: 2em;
	flex-shrink: 0;
}
.modal-body[data-v-584b62a6] {
	max-height: 85vh;
	overflow-y: scroll;
	will-change: transform;
	background-color: rgba(255, 255, 255, 0.1);
	padding: 0.5em;
	border-radius: 0.5em;
	flex-shrink: 1;
}
.modal-default-button[data-v-584b62a6] {
	position: absolute;
	top: 0.2em;
	right: 0.2em;
}
.modal-controls[data-v-584b62a6] {
	position: absolute;
	top: 0.2em;
	right: 3em;
}
.modal-enter-active[data-v-584b62a6],
.modal-leave-active[data-v-584b62a6] {
	transition: all 0.2s ease;
}
.modal-footer[data-v-584b62a6] {
	text-align: right;
	flex-shrink: 0;
}
.modal-enter-from[data-v-584b62a6] {
	opacity: 0;
}
.modal-leave-active[data-v-584b62a6] {
	opacity: 0;
}
.modal-enter-from .modal-container[data-v-584b62a6],
.modal-leave-active .modal-container[data-v-584b62a6] {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}
`, "",{"version":3,"sources":["webpack://./client/src/components/Modal.vue"],"names":[],"mappings":";AAyDA;CACC,eAAe;CACf,aAAa;CACb,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,oCAAoC;CACpC,cAAc;CACd,6BAA6B;AAC9B;AAEA;CACC,mBAAmB;CACnB,sBAAsB;CACtB,gBAAgB;AACjB;AAEA;CACC,0BAA0B;CAC1B,uBAAuB;CACvB,kBAAkB;CAClB,cAAc;CACd,cAAc;CACd,YAAY;CACZ,qCAAqC;CACrC,kBAAkB;CAClB,yCAAyC;CACzC,yBAAyB;CACzB,aAAa;CACb,sBAAsB;CACtB,gBAAgB;AACjB;AAEA;AACC;EACC,eAAe;EACf,cAAc;AACf;AACD;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;AACf;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,sBAAsB;CACtB,0CAA0C;CAC1C,cAAc;CACd,oBAAoB;CACpB,cAAc;AACf;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;AACb;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;AAEA;;CAEC,yBAAyB;AAC1B;AAEA;CACC,iBAAiB;CACjB,cAAc;AACf;AAEA;CACC,UAAU;AACX;AAEA;CACC,UAAU;AACX;AAEA;;CAEC,6BAA6B;CAC7B,qBAAqB;AACtB","sourcesContent":["<template>\n\t<transition name=\"modal\" appear>\n\t\t<div class=\"modal-mask\" v-if=\"displayed\">\n\t\t\t<div class=\"modal-wrapper\" @click=\"close($event)\">\n\t\t\t\t<div class=\"modal-container\">\n\t\t\t\t\t<div class=\"modal-header\">\n\t\t\t\t\t\t<slot name=\"header\"></slot>\n\t\t\t\t\t\t<div class=\"modal-controls\">\n\t\t\t\t\t\t\t<slot name=\"controls\"></slot>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<font-awesome-icon\n\t\t\t\t\t\t\t@click=\"$emit('close')\"\n\t\t\t\t\t\t\tclass=\"modal-default-button clickable\"\n\t\t\t\t\t\t\ticon=\"fa-solid fa-times\"\n\t\t\t\t\t\t\tsize=\"lg\"\n\t\t\t\t\t\t\taria-hidden=\"true\"\n\t\t\t\t\t\t/>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=\"modal-body\">\n\t\t\t\t\t\t<slot name=\"body\">Loading...</slot>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=\"modal-footer\">\n\t\t\t\t\t\t<slot name=\"footer\"></slot>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</transition>\n</template>\n\n<script lang=\"ts\">\nimport { defineComponent } from \"vue\";\n\nexport default defineComponent({\n\tname: \"Modal\",\n\tprops: { displayed: { type: Boolean, default: true } },\n\tmethods: {\n\t\tclose(e: Event) {\n\t\t\tif (e.target == e.currentTarget) this.$emit(\"close\");\n\t\t},\n\t\tshortcuts(e: KeyboardEvent) {\n\t\t\tif (e.key === \"Escape\") this.$emit(\"close\");\n\t\t},\n\t},\n\tmounted() {\n\t\t(document.activeElement as HTMLElement).blur();\n\t\tdocument.addEventListener(\"keydown\", this.shortcuts);\n\t},\n\tbeforeUnmount() {\n\t\tdocument.removeEventListener(\"keydown\", this.shortcuts);\n\t},\n});\n</script>\n\n<style scoped>\n.modal-mask {\n\tposition: fixed;\n\tz-index: 1020;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: rgba(0, 0, 0, 0.5);\n\tdisplay: table;\n\ttransition: opacity 0.3s ease;\n}\n\n.modal-wrapper {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n\tmax-width: 100vw;\n}\n\n.modal-container {\n\twidth: -webkit-fit-content;\n\twidth: -moz-fit-content;\n\twidth: fit-content;\n\tmax-width: 95%;\n\tmargin: 0 auto;\n\tpadding: 1em;\n\tbackground-color: rgba(32, 32, 32, 1);\n\tborder-radius: 1em;\n\tbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n\ttransition: all 0.3s ease;\n\tdisplay: flex;\n\tflex-direction: column;\n\tmax-height: 90vh;\n}\n\n@media (orientation: portrait) and (max-width: 500px) {\n\t.modal-container {\n\t\tmax-width: 100%;\n\t\tpadding: 1em 0;\n\t}\n}\n\n.modal-header {\n\tposition: relative;\n\ttext-align: center;\n\tpadding-left: 2em;\n\tpadding-right: 2em;\n\tflex-shrink: 0;\n}\n\n.modal-body {\n\tmax-height: 85vh;\n\toverflow-y: scroll;\n\twill-change: transform;\n\tbackground-color: rgba(255, 255, 255, 0.1);\n\tpadding: 0.5em;\n\tborder-radius: 0.5em;\n\tflex-shrink: 1;\n}\n\n.modal-default-button {\n\tposition: absolute;\n\ttop: 0.2em;\n\tright: 0.2em;\n}\n\n.modal-controls {\n\tposition: absolute;\n\ttop: 0.2em;\n\tright: 3em;\n}\n\n.modal-enter-active,\n.modal-leave-active {\n\ttransition: all 0.2s ease;\n}\n\n.modal-footer {\n\ttext-align: right;\n\tflex-shrink: 0;\n}\n\n.modal-enter-from {\n\topacity: 0;\n}\n\n.modal-leave-active {\n\topacity: 0;\n}\n\n.modal-enter-from .modal-container,\n.modal-leave-active .modal-container {\n\t-webkit-transform: scale(1.1);\n\ttransform: scale(1.1);\n}\n</style>\n\n<style>\n.modal-header h2 {\n\tmargin-top: 0;\n\tmargin-bottom: 0.25em;\n}\n\n/* Overrides for buttons in footer */\n\n.actions {\n\tdisplay: flex;\n\tz-index: 1;\n\tbox-sizing: border-box;\n\tflex-wrap: wrap;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 100%;\n\tmargin: 1em auto 0;\n\tpadding: 0;\n}\n\n/* We have to provide more specialized selectors than the default #main-container button */\n\n.actions button,\n#main-container .actions button {\n\twidth: auto;\n\theight: auto;\n\tmargin: 0.3125em;\n\tpadding: 0.625em 1.1em;\n\tbox-shadow: none;\n\tfont-weight: 500;\n\tborder: 0;\n\tborder-radius: 0.25em;\n\tcolor: #fff;\n\tfont-size: 1em;\n\ttext-transform: none;\n\tletter-spacing: initial;\n}\n\n.actions button.cancel,\n#main-container .actions button.cancel {\n\tbackground-color: rgb(221, 51, 51);\n}\n\n.actions button:hover,\n#main-container .actions button:hover {\n\tbackground-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1));\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
